import { createContext, useContext, useEffect, useState } from "react";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = loading
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const email = localStorage.getItem("email");

    if (token && email) {
      setUser({ token, email });
    } else {
      setUser({ token: null, email: null });
    }
    setLoading(false);
  }, []);

  const loginUser = ({ email, token }) => {
    localStorage.setItem("authToken", token);
    localStorage.setItem("email", email);
    setUser({ email, token });
  };

  const logoutUser = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("email");
    setUser({ email: null, token: null });
  };

  return (
    <UserContext.Provider value={{ user, loginUser, logoutUser, loading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
